import { create as createSearchItem, TSearchItem } from 'legacy/lut/classes/models/SearchItem'

class SearchItemMapper {
  public static map(rows: any[], highlightWords: string[]): TSearchItem[] {
    const emptyItem = createSearchItem()
    return rows.map((row: any) => {
      const data: any = {}
      Object.keys(emptyItem).forEach((key) => {
        data[key] = row[key] || emptyItem[key]
      })

      data['highlightWords'] = highlightWords
      return createSearchItem(data)
    }) as TSearchItem[]
  }
}

export default SearchItemMapper
